
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.738 14.95C3.563 20.49.923 21.959 0 22h24l-3.139-3.834c-1.138-1.526-3.489-4.651-3.784-4.948-3.323-3.958-6.37-5.195-10.339 1.732z","fill":"#525F7F"}}),_c('path',{attrs:{"d":"M14.896 15.537C12.118 20.617 9.808 21.962 9 22h21l-2.746-3.515c-.996-1.398-3.053-4.263-3.312-4.535-2.907-3.628-5.573-4.762-9.046 1.587z","fill":"#B4BCCF"}})])
          )
        }
      }
    